export default __webpack_public_path__ + "static/media/garage-icon.76fa0a93.svg";